export const getSender = (loggedInUser, users) => {
    const name = users[0]?._id === loggedInUser?._id ? users[1]?.name : users[0]?.name;

    return name;
}